export default __webpack_public_path__ + "static/media/city-hall-survey.d46c8620.svg";